export default __webpack_public_path__ + "static/media/bsc-grey-icon.a1fd7089.svg";